<template>
  <el-dialog
    width="1000px"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="default-dialog"
  >
   <div class="title">模板设置</div>
   <div class="acc_flex template_container">
      <div class="template_item" @click="addTask">
        <div class="item_title">新增模板</div>
        <div class="item_box add">
            <i class="el-icon-plus"></i>
        </div>
      </div>
       <div class="template_item" v-for="(item,i) in list " :key="i">
        <div class="item_title">{{item.name}}</div>
        <div class="item_box ">
            <div class="item_content" v-if="item.invoiceVoucherAddendumTemList&&item.invoiceVoucherAddendumTemList.length">
                <div v-for="(child,childI) in item.invoiceVoucherAddendumTemList" :key="childI" style="margin-bottom:5px;">
                    {{`${child.creditDirection}方：${child. subjectName}`}}
                </div>
            </div>
            <transition name="fade">
                <div class="item_task">
                    <el-button type="text" @click="editTask(item)">编辑</el-button>
                    <el-button type="text" style="color:red;" @click="deleteTask(item)">删除</el-button>
                </div>
            </transition>
        </div>
      </div>
   </div>
   <!-- 生成凭证-->
   <GenerateVoucher ref='generateVoucher' @refsh="queryTemplate"/>
  </el-dialog>
</template>

<script>
import GenerateVoucher from './GenerateVoucher.vue';
import {findSalaryVoucherTemplate,deleteTemplate} from '@/api/index.js'
export default {
    components:{
        GenerateVoucher
    },
    data(){
        return {
            visible:false,
            list:[],
        }
    },
    methods:{
        // 计提发放模板
        queryTemplate(){
            findSalaryVoucherTemplate().then(res=>{
                if(res.data.code==1){
                    console.log(res.data.data)
                    this.list = res.data.data
                }
            })
        },
        editTask(item){
            this.$refs.generateVoucher.openTask('edit',item)
        },
        addTask(){
          this.$refs.generateVoucher.openTask('add')
        },
        deleteTask(item){
            this.$confirm(`是否删除${item.name}?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(()=>{
                deleteTemplate({id:item.id}).then(res=>{
                    if(res.data.code==1){
                        this.$message.success(res.data.msg)
                        this.queryTemplate()
                    }
                })
            })
        },
        openTask(){
            this.visible = true
            this.queryTemplate()
        },
    },
};
</script>

<style lang="less" scoped>
.template_container {
    flex-wrap: wrap;
    .template_item{
        display: flex;
        flex-direction: column;
        margin-right: 60px;
        margin-bottom: 20px;
        .item_title{
            color: #000;
            font-size: 16px;
            font-weight: bold;
        }
        .add {
            padding: 30px !important;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 26px;
        }
        .item_box {
            position: relative;
            margin-top: 5px;
            height: 140px;
            padding: 20px;
            padding-right: 0;
            border-radius: 4px;
            box-sizing: border-box;
            border: 1px dashed #333333;
            transition: all .3s;
            width: 250px;
            color: #000;
            .item_content {
                height: 70px; 
                //  overflow: hidden;
        //   text-overflow: ellipsis;
        //   display: -webkit-box;
        //   -webkit-line-clamp: 3; //行数
        //   -webkit-box-orient: vertical;
                &>div {
                    white-space: nowrap;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                margin-right: 10px;
            }
            &:hover .item_task {
                display: block;
            }
            .item_task {
                position: absolute;
                display: none;
                transition: all .3s;
                right: 10px;
                bottom: 5px;
                /deep/ .el-button {
                    padding: 0 !important;
                }
            }
        }
    }
   
}
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}
/deep/ .el-dialog__header {
    padding: 0 !important;
}
/deep/ .el-dialog__footer {
  display: none !important;
}
/deep/ .el-dialog__body {
  padding: 40px 30px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/VoucherSetting.vue